<template>
  <ul class="navbar main-background" role="menu" aria-label="Menu">
    <li role="menuitem">
      <router-link :to="{name: 'ExploreCampus'}" tag="a">
        <img role="presentation" src="../assets/explore.png" alt="">
        {{ $t("message.exploreCampus") }}
      </router-link>
    </li>
    <li role="menuitem">
      <router-link :to="{name: 'CuratedTour'}" tag="a">
        <img role="presentation" src="../assets/curated.png" alt="">
        {{ $t("message.curatedTour") }}
      </router-link>
    </li>
    <li role="menuitem">
      <router-link :to="{name: 'PersonalizedCategories'}" tag="a">
        <img role="presentation" src="../assets/personalized.png" alt="">
        {{ $t("message.personalizedTour") }}
      </router-link>
    </li>
    <li role="menuitem">
      <router-link :to="{name: 'ExploreCampus', query: { search_focus: true }}" tag="a">
        <img role="presentation" src="../assets/search-new.svg" alt="">
        {{ $t("button.search") }}
      </router-link>
    </li>
    <li role="menuitem">
      <router-link :to="{name: 'Notes'}" tag="a">
        <img role="presentation" src="../assets/Notes-01-512.svg" alt="">
        {{ $t("message.viewNotes") }}
      </router-link>
    </li>
    <li role="menuitem">
      <router-link :to="{name: 'About'}" tag="a">
        <img role="presentation" src="../assets/info-white.svg" alt="">
        {{ $t("message.about") }}
      </router-link>
    </li>
    <li class="languages" role="menuitem">
      <slot></slot>
      <ul class="main-background" v-if="languageDropdownOpen">
        <li v-if="locale !== 'es' && isEnabledLanguage($consts.languagesIds.spanish)" role="menuitem">
          <button
            @click="selectLanguage('es')"
            @keypress.enter="selectLanguage('es')"
          >
            <img role="presentation" src="../assets/spanish.png" alt="">
            {{ $t("button.langSpanish") }}
          </button>
        </li>
        <li v-if="locale !== 'en' && isEnabledLanguage($consts.languagesIds.english)" role="menuitem">
          <button
            @click="selectLanguage('en')"
            @keypress.enter="selectLanguage('en')"
          >
            <img role="presentation" src="../assets/us.png" alt="">
            {{ $t("button.langEnglish") }}
          </button>
        </li>
        <li v-if="locale !== 'ko' && isEnabledLanguage($consts.languagesIds.korea)" role="menuitem">
          <button
            @click="selectLanguage('ko')"
            @keypress.enter="selectLanguage('ko')"
          >
          <img role="presentation" src="../assets/korea.png" alt="">
          {{ $t("button.langKorean") }}
        </button>
        </li>
        <li v-if="locale !== 'fr' && isEnabledLanguage($consts.languagesIds.france)" role="menuitem">
          <button
            @click="selectLanguage('fr')"
            @keypress.enter="selectLanguage('fr')"
          >
            <img role="presentation" src="../assets/france.png" alt="">
            {{ $t("button.langFrench") }}
          </button>
        </li>
        <li v-if="locale !== 'cmn' && isEnabledLanguage($consts.languagesIds.chinaMandarin)" role="menuitem">
          <button
            @click="selectLanguage('cmn')"
            @keypress.enter="selectLanguage('cmn')"
          >
            <img role="presentation" src="../assets/china.png" alt="">
            {{ $t("button.langChineseMandarin") }}
          </button>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'HeaderNavbar',
  props: ['languageDropdownOpen'],
  methods: {
    ...mapActions([
      'changeLanguage'
    ]),
    isEnabledLanguage (language) {
      return this.$store.state.college.languages.includes(language)
    },
    selectLanguage (language) {
      this.changeLanguage(language)
      this.$emit('change')
    }
  },
  computed: {
    ...mapState(['locale']),
    ...mapState({
      menu_links: state => state.college.settings.menu_links,
      languages: state => state.college.languages
    })
  }
}
</script>
